import "core-js/modules/es.array.concat.js";
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getValidKeys } from "../../../../store/Selectors";
import CloseButton from "./CloseButtonCore";
import { useCefEventTracker } from "../../Hooks/useCefEventTracker";
import { CefEvent, CefEventName, Platform } from "../../../../EventTracker";
import { useIsMobile } from "../useIsMobile";
import { getStepName, getPageName } from "../../../../EventTracker/utilities";
import { useAppContext, EligibilityResultsContext } from "../../Providers";
import { studentOnboarding } from "../../../controller/consts";
var ConnectedCloseButton = function ConnectedCloseButton(_ref) {
  var validKeys = _ref.validKeys,
    onClick = _ref.onClick,
    onExit = _ref.onExit;
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var _useAppContext = useAppContext(),
    showSaveAndExitModal = _useAppContext.showSaveAndExitModal,
    onboardingMode = _useAppContext.onboardingMode;
  var _useContext = useContext(EligibilityResultsContext),
    eligibilityResults = _useContext.eligibilityResults;
  var isMobile = useIsMobile();
  var history = useHistory();
  var handleClose = function handleClose() {
    if (!showSaveAndExitModal && (validKeys === null || validKeys === void 0 ? void 0 : validKeys.length) > 0) {
      var _eligibilityResults$r;
      onClick();
      if ((eligibilityResults === null || eligibilityResults === void 0 ? void 0 : (_eligibilityResults$r = eligibilityResults.result) === null || _eligibilityResults$r === void 0 ? void 0 : _eligibilityResults$r.eligibility) === 'ineligible') {
        trackEvent({
          event: "".concat(studentOnboarding, " - CEF - Not Eligible: Dismissed Not-Eligible Page"),
          group: studentOnboarding
        });
      }
    } else {
      trackEvent(CefEvent(CefEventName.CancelledEligibilityCheck, isMobile ? Platform.Mobile : Platform.Desktop, {
        step: getStepName(history.location.pathname)
      }));
      if (onboardingMode) {
        trackEvent({
          event: "".concat(studentOnboarding, " - CEF: Dismissed ").concat(getPageName(history.location.pathname)),
          group: studentOnboarding
        });
      }
      onExit();
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: function onClick() {
      return handleClose();
    }
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var validKeys = getValidKeys(state);
  return {
    validKeys: validKeys
  };
};
export default connect(mapStateToProps)(ConnectedCloseButton);